export interface ProductAdditionalCost {
  name: string;
  amount: number;
  id: string;
  tax_id: string;
  description: string;
}
